module.exports = __webpack_public_path__ + "static/media/ios-unlock.6d951272.svg";